import React from 'react';
import { getCurrentUser } from 'api/provider';
import { TCurrentUser } from 'types/group';
import { isOpPortal } from 'utils/common';

let globalUser: TCurrentUser | undefined;
let globalPromise: Promise<void> | null = null;
const globalListeners: Set<() => void> = new Set();

const notifyListeners = () => {
    globalListeners.forEach((fn) => fn());
};

const fetchCurrentUser = async () => {
    if (isOpPortal()) {
        return;
    }
    try {
        const result = await getCurrentUser();
        if (!result.error) {
            globalUser = result?.data?.data;
        }
    } catch (e) {
        console.error(e);
    }
    globalPromise = null;
    notifyListeners();
};

const ensureFetched = () => {
    if (globalUser) return;
    if (!globalPromise) {
        globalPromise = fetchCurrentUser();
    }
};

const useCurrentUser = (): [TCurrentUser | undefined, boolean, () => void] => {
    const [, forceUpdate] = React.useReducer((x: number) => x + 1, 0);
    const loading = !!globalPromise;

    React.useEffect(() => {
        globalListeners.add(forceUpdate);
        ensureFetched();
        return () => {
            globalListeners.delete(forceUpdate);
        };
    }, []);

    const refetch = React.useCallback(() => {
        globalPromise = fetchCurrentUser();
        notifyListeners();
    }, []);

    return [globalUser, loading, refetch];
};

export default useCurrentUser;
